<div class="chart-container" [ngClass]="{'dark-mode': isDarkTheme}">
  <div class="chart-heading">Top 10 NAICS Levels</div>
  @if (!allSectors.length) {
    <p class="no-data-msg">No NAICS industry data found in the current dataset</p>
  }

  <!-- Sector picker -->
  <div class="sector-controls" *ngIf="allSectors.length">
    <div class="control-group">
      <label class="control-label">Sector</label>
      <select class="sector-native-select" (change)="onSectorChange($event)">
        <option value="" [selected]="selectedSectorCode === ''">All Sectors</option>
        <option *ngFor="let sector of allSectors" [value]="sector.code"
          [selected]="sector.code === selectedSectorCode">
          {{ sector.friendly }} ({{ sector.count | number }})
        </option>
      </select>
    </div>
    <div class="control-group">
      <label class="control-label">Aggregation Level</label>
      <select class="sector-native-select" (change)="onLevelChange($event)">
        <option *ngFor="let level of digitLevels" [value]="level.agglevel"
          [selected]="level.agglevel === selectedAggLevel">
          {{ level.friendly }}
        </option>
      </select>
    </div>
  </div>

  <div class="stats">
    <!-- Top 10  in the selected sector -->
    <div class="list-panel" *ngIf="allSectors.length">
      <div class="chart-sub-heading">Top 10 {{ selectedTrimmedLabel }} - {{ selectedSectorLabel }}</div>
      @if (selectedSectorIndustries.length) {
        <div class="ranking-list">
          <div class="ranking-item" *ngFor="let item of selectedSectorIndustries">
            <span class="rank-badge" [style.background-color]="getSectorColor(item.sectorCode)">{{ item.rank }}</span>
            <div class="ranking-info">
              <span class="ranking-title">{{ item.title }}</span>
              <span class="ranking-meta">NAICS {{ item.code }}<ng-container *ngIf="!selectedSectorCode"> | {{ item.sectorFriendly }}</ng-container></span>
            </div>
            <span class="ranking-count">{{ item.count | number }}</span>
          </div>
        </div>
      } @else {
        <p class="no-data-msg">No industry data for this sector</p>
      }
    </div>
  </div>
</div>
